import {EntityService} from "../entity-service"
import {CollectionRequest} from "@/model/entity/collection-request/collection-request"
import {AxiosPromise} from "axios"
import {classToPlain, plainToClass} from "class-transformer"

class ColectionRequestService extends EntityService<CollectionRequest> {

  constructor() {
    super("collection_request", CollectionRequest)
  }

  create(entity: CollectionRequest): AxiosPromise<any> {
    entity = plainToClass(this.classType, entity)
    return this.$http.post(this.path + "/new", classToPlain(entity))
  }

  cancel(collectionRequestIds: number[]): AxiosPromise {
    let queryPath = this.path + "/cancel_collection_requests_from_ids" + "?"
    collectionRequestIds.forEach(id => (queryPath += "collectionRequestId=" + id + "&"))
    return this.$http.delete(queryPath)
  }

  geodata(colReqIds: number[]) {
    let queryPath = this.path + "/geodata" + "?"
    colReqIds.forEach(id => (queryPath += "colReqId=" + id + "&"))
    return this.$http({
      method: "get",
      url: queryPath,
      responseType: "arraybuffer"
    })
  }

  checkPickupZipCodeCountry(entity: CollectionRequest) {
    return this.$http.get("deliveryAddress/check?zipcode=" + entity.pickupAddress.postalCode + "&countryCode="
    + entity.pickupAddress.country.isoCodeAlpha2 + "&city=" + entity.pickupAddress.city)
  }

  checkDeliveryZipCodeCountry(entity: CollectionRequest) {
    return this.$http.get("deliveryAddress/check?zipcode=" + entity.deliveryAddress.postalCode + "&countryCode="
    + entity.deliveryAddress.country.isoCodeAlpha2 + "&city=" + entity.deliveryAddress.city)
  }
}

export interface ICollectionRequestService extends EntityService<CollectionRequest> {
  geodata(colReqIds: number[]): AxiosPromise
  cancel(collectionRequestIds: number[]): AxiosPromise
}

const service = new ColectionRequestService()

export const collectionRequestService = service
